import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowRight } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Category } from '@/types';

interface CategoryCardProps {
  category: Category;
  className?: string;
  serverId?: string;
}

export function CategoryCard({ category, className = '', serverId }: CategoryCardProps) {
  const { t } = useTranslation();
  const href = serverId ? `/loja/${serverId}/${category.slug}` : `/loja/${category.slug}`;
  return (
    <Link to={href}>
      <Card className={`group overflow-hidden card-interactive bg-card border-border h-full ${className}`}>
        <div className="relative h-32 overflow-hidden">
          <img
            src={category.image}
            alt={category.name}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-card to-transparent" />
          <Badge
            variant="outline"
            className="absolute top-3 left-3 bg-background/80 backdrop-blur-sm border-border text-xs"
          >
            {t('store.shop.category_badge')}
          </Badge>
        </div>
        <CardContent className="p-4">
          <div className="flex items-center justify-between">
            <div>
              <h3 className="font-display font-semibold text-lg text-foreground group-hover:text-primary transition-colors">
                {category.name}
              </h3>
              <p className="text-sm text-muted-foreground">
                {t('store.shop.product_count', { count: category.productCount || 0 })}
              </p>
            </div>
            <ArrowRight className="w-5 h-5 text-muted-foreground group-hover:text-primary group-hover:translate-x-1 transition-all" />
          </div>
        </CardContent>
      </Card>
    </Link>
  );
}

export default CategoryCard;
